import React from 'react';

import { Icons } from './icon-constants';

import type { BaseIconProps } from './icon-utils';

// Re-export Icons for backward compatibility
export { Icons };

// Re-export theme provider for backward compatibility
// Note: useIconTheme hook should be imported directly from './icon-theme-hooks' to avoid React refresh warnings

// Context-specific icon components for common use cases

export const ActionIcon: React.FC<BaseIconProps & { icon: keyof typeof Icons }> = ({
  icon,
  size = 'sm',
  color = 'secondary',
  className = '',
  ...props
}) => {
  const IconComponent = Icons[icon];
  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
      data-testid={`action-icon-${icon.toLowerCase()}`}
      {...props}
    />
  );
};

export const StatusIcon: React.FC<BaseIconProps & { icon: keyof typeof Icons }> = ({
  icon,
  size = 'md',
  color = 'warning',
  className = '',
  ...props
}) => {
  const IconComponent = Icons[icon];
  return <IconComponent size={size} color={color} className={className} {...props} />;
};

// Theme provider is exported from './icon-theme-provider'
